import { createSelector } from 'reselect';
import { EventMode, EventCategory } from '../../../../../types/eventTypes';
import { getDefaultEventDetailsState } from './modules';
import { TEventListState } from './types';

const eventsState = (state: any) => state.events as TEventListState;

export const createEventSelector = (
  mode: EventMode,
  category: EventCategory
) => {
  return createSelector(eventsState, (state) => state[mode][category] || getDefaultEventDetailsState(category, mode));
};
